<template>
    <fragment v-html="svg"></fragment>
</template>

<script>
    export default {
        name: 'svg-inline',
        props: ['name'],
        data() {
            return {
                svg: ''
            };
        },
        created() {
            try {
                this.svg = require(`../../../svg/${this.name}.svg`);
            } catch(ex) {
                console.log(`can't find ${this.name}.svg`);
            }
        }
    };
</script>